import { marked } from 'marked'

/**
 * 全局唯一的 markdown 渲染入口（聊天流式 / 知识条目预览 / 差评 LLM 分析共用）
 *
 * XSS 清理规则（变更须过 golden-assistant-check + 浏览器 UAT）：
 * 1. script/iframe/style 块整体移除；
 * 2. 事件属性（on 开头）——值须覆盖无引号形态：marked 原样输出无引号属性
 *    （onerror=alert(1)），只匹配带引号会被绕过（浏览器解析 innerHTML 时才补引号）；
 * 3. 伪协议 href/src（javascript:/vbscript:/data:text/html）整属性移除。
 * 代码块（pre）内容是合法展示对象（示例代码），清理只作用于 pre 之外的分段。
 * @param {string} text Markdown 原文
 * @param {Object} [options] marked 参数（聊天/预览传 { breaks: true }，差评分析用默认）
 * @return {string} 清理后的 HTML
 */
export function renderMarkdown (text, options) {
  const raw = marked.parse(text || '', { breaks: true, async: false, ...options })
  // 两种保护形态：marked 解析出的 pre 代码块；以及 marked 未解析、原样保留的 ``` 围栏文本
  // （块级 HTML 开头的文本里 marked 不解析其后围栏——示例代码是合法展示内容，同样须保护）
  return raw
    .split(/(<pre[\s\S]*?<\/pre>|```[\s\S]*?```)/gi)
    .map(seg => (/^(<pre|```)/i.test(seg) ? seg : sanitizeSegment(seg)))
    .join('')
}

/**
 * 清理单个非代码块片段
 * @param {string} html 片段 HTML
 * @return {string} 清理后片段
 */
function sanitizeSegment (html) {
  return String(html)
    .replace(/<(script|iframe|style)[\s\S]*?<\/\1>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/\s(href|src)\s*=\s*("\s*(?:javascript|vbscript|data:text\/html)[^"]*"|'\s*(?:javascript|vbscript|data:text\/html)[^']*'|(?:javascript|vbscript|data:text\/html)[^\s>]*)/gi, '')
}
